import { z } from 'zod';

import { preprocessEmptyStringAsUndefined } from '@dealstack/shared/lib/common/common.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { SecurityCatchUpRightsBasis } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const SecurityCatchUpRightsShape = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) =>
	z.object({
		target: z.preprocess(
			preprocessEmptyStringAsUndefined,
			z
				.number()
				.max(100)
				.refine((val) => val !== undefined && val > 0, {
					message: tCapManage(
						'securities.catch_up_rights.validation.target.greater_than_0'
					),
				})
		),
		basis: z.nativeEnum(SecurityCatchUpRightsBasis),
	});

export type SecurityCatchUpRightsFormDto = z.infer<ReturnType<typeof SecurityCatchUpRightsShape>>;
